<template>
	<div class="scan">
    <div class="header">
      <h1 class="statistics">待处理订单：<span class="num" v-if="unreceived">{{unreceived}}</span> <i class="el-icon-loading" v-else></i></h1>
      <search-input @getSearchData="getSearchData" :targetStatus="this.$route.params.status" placeholder="请输入生产条码号"></search-input>
    </div>
    <div class="scan-tip">
      扫码状态：<i v-if="isCanScan" class="el-icon-success" style="color:#67c243;"></i><i v-else class="isCanScan el-icon-error" style="color:red;"></i>
      <span>{{isCanScan ? '（确保输入法在英文状态下进行扫描）' : '（点击对话框任意空白处恢复到扫码状态）'}}</span>
    </div>
    <!-- 表单 -->
    <prepared-form v-model="form" ref="child" @getResult="getResult" @updateLoading="updateLoading" @updateAllSize="updateAllSize"></prepared-form>
    <pt-sub-title :title="currentTitle"></pt-sub-title>
    <lot-operate-list v-model="submitList" :show-fields="showFields" :loading="loading">
        <el-button type="text" slot-scope="scope" @click="removeFromList(scope.row)">移除</el-button>
    </lot-operate-list>
    <input type="text" class="scan-input" v-focus style="width:0;height:0;border:none;" @focus="enabledScan" @blur="disabledScan" v-model="scanValue" @keydown.enter="autoSubmit(scanValue)"/>
  </div>
</template>
<script>
import searchInput from '../../components/search-input'
import lotOperateList from 'cps/lab-order/lot-operate-list'
import preparedForm from '../components-with-data/prepared-form.vue'
export default {
  name: 'process-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    batchNum: {
      type: String,
      required: false
    },
    lot: {
      type: [String, Number],
      required: false
    },
    quantity: {
      type: String
    },
    lotsDatas: {
      type: Array,
      defalut: function () {
        return []
      }
    },
    // 是否从左侧菜单全部订单下面的批量操作进入 如果是此批操作进入则不显示扫码操作和手动搜索 以及不需要传batchNum
    lotIn: {
      type: Boolean,
      default: false
    },
    showFields: {
      type: Array,
      defalut: function () {
        return []
      }
    }
  },
  components: {
    lotOperateList,
    preparedForm,
    searchInput
  },
  computed: {
    currentTitle () {
      return '已扫描样本（' + this.submitList.length + '/' + this.unreceived + '）'
    }
  },
  data () {
    return {
      searching: false,
      loading: false,
      searchParams: { batchNumber: this.batchNum },
      serachValue: [],
      submitList: [],
      unHandle: 0,
      notificeRefresh: false,
      mouseDown: false,
      isCanScan: false,
      scanValue: '',
      unreceived: this.quantity,
      form: {}
    }
  },
  watch: {
    quantity (val, old) {
      this.unreceived = val
    }
  },
  methods: {
    getSearchData (data) {
      this.checkData(data)
    },
    checkData (data) {
      let ids = this.submitList.map(e => e.id)
      data.forEach((item, index) => {
        if (!ids.includes(item.id)) {
          this.submitList.push(item)
        } else {
          this.$message.warning('该样本已经在列表里了')
        }
      })
      if (!data.length) {
        this.$message.warning('该状态没有检索到该样本')
      }
    },
    setMouseDown () {
      this.mouseDown = true
    },
    disabledScan () {
      if (this.mouseDown) {
        return
      }
      this.isCanScan = false
    },
    enabledScan () {
      this.isCanScan = true
    },
    autoSubmit (key) {
      if (!key) {
        this.$message.warning('没有扫描到条码')
        return
      }
      // key = key.replace(/-/g, '')
      let params = {
        needActionTaskInfo: true,
        pageableParam: { page: 0, size: 9999 },
        labCode: key,
        targetStatus: this.$route.params.status,
        statusTime: [{ startTime: '', endTime: '', targetStatus: this.$route.params.status }]
      }

      this.loading = true
      this.scanValue = ''
      // getGeneLabOrders
      this.$store.dispatch('AdultexcludeTask', params).then(response => {
        console.log('response--------', response.data)
        this.checkData(response.data)
        this.loading = false
      }).catch(err => {
        this.$message.warning(err)
        this.loading = false
        console.log(err)
      })
    },
    // visibleHandle (val) {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', val)
    // },
    // close () {
    //   this.notificeRefresh && this.$emit('refresh')
    //   this.$emit('update:dialogVisible', false)
    // },
    activeTab () {
      if (document.visibilityState === 'hidden') { // 状态判断
        this.isCanScan = false
      } else {
        this.isCanScan = true
      }
    },
    removeFromList (data) {
      let id = data.id
      this.submitList.forEach((e, index) => {
        if (e.id === id) {
          this.submitList.splice(index, 1)
        }
      })
    },
    getResult () {
      this.$emit('updateLoading', false)
      this.$emit('refresh')
      this.$emit('update:dialogVisible', false)
    },
    updateLoading (val) {
      this.$emit('updateLoading', val)
    },
    scanSubmit () {
      console.log('scanSubmit')
      this.$refs.child.formValidate().then(() => {
        if (!this.submitList.length) {
          this.$message.warning('请扫描样本！')
          // this.$confirm('您未扫描任何样本，点击确定则提交整个批次, 是否继续?', '提示', { type: 'warning' }).then(() => {
          //   // 执行整个批次的接口
          //   this.$emit('updateLoading', true)
          //   this.$refs.child.submitForm([], this.batchNum)
          // }).catch((ee) => {
          //   this.$message.warning('已取消操作!')
          // })
        } else {
          // 将扫描的执行接口
          this.$emit('updateLoading', true)
          this.$refs.child.submitForm(this.submitList.map(e => e.id), this.batchNum)
        }
      })
    },
    updateAllSize (val) {
      // 执行成功后清空表格
      this.submitList = []
      this.$emit('updateAllSize', val)
    }
  },
  created () {
    // 监听浏览器tab切换事件
    document.addEventListener('visibilitychange', this.activeTab)
  },
  beforeDestory () { // 解绑事件监听
    document.removeEventListener('visibilitychange', this.activeTab)
  }
}
</script>
<style lang="less">
.scan{
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
	.scan-tip{
		font-size:18px;
		padding:20px 0;
	}
}
</style>
